import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { FacilityInvitationPdfsApi } from '../../../apis/InvitationApi/FacilityInvitationPdfsApi.ts';

interface DeleteInvitationPdfVars {
    facilityId: number;
    language: string;
    filename: string;
}

export function useDeleteFacilityInvitationPdf() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation<void, AppMedError, DeleteInvitationPdfVars>({
        mutationKey: [QueryKeys.facilityInvitationPdfs, 'delete'],
        mutationFn: ({ facilityId, language, filename }) =>
            FacilityInvitationPdfsApi.remove(facilityId, language, filename),
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.facilityInvitationPdfs, vars.facilityId],
            });
            notifications.show({
                color: 'green',
                message: t('invitationPdf.admin.removed'),
            });
        },
        onError: (err) => {
            notifications.show({ color: 'red', message: err.message });
        },
    });
}
